import { Skeleton, Stack } from '@mui/material';

const JobInformationSkeleton = () => {
    return (
        <>
            <div className="pt-1 centerClass" style={{ width: '98%' }}>
                <Stack spacing={3}>
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'82px'} />
                </Stack>
            </div>
        </>
    );
};

export default JobInformationSkeleton;
